import { useCallback, useEffect, useState } from 'react';
import './LogViewer.css';
import { authFetch } from '../auth';

const API_BASE = '/api';
const PREVIEW_LEN = 60; // 표에서 보여줄 최대 길이

const ACTION_LABELS = {
  LOGIN: '로그인',
  LOGIN_FAIL: '로그인 실패',
  ACCOUNT_CREATE: '계정 생성',
  ACCOUNT_UPDATE: '계정 수정',
  ACCOUNT_SUSPEND: '계정 정지',
  ACCOUNT_PURGE: '계정 자동삭제',
  PASSWORD_CHANGE: '비밀번호 변경',
  CMS_SAVE: '콘텐츠 저장',
  CMS_DELETE: '콘텐츠 삭제',
};
const actionLabel = (a) => ACTION_LABELS[a] || a;
const actionClass = (a) => {
  if (a === 'LOGIN') return 'login';
  if (a === 'LOGIN_FAIL') return 'fail';
  if (a === 'ACCOUNT_SUSPEND' || a === 'CMS_DELETE') return 'suspend';
  return 'edit';
};
const preview = (s) => {
  if (!s) return '';
  return s.length > PREVIEW_LEN ? s.slice(0, PREVIEW_LEN) + '…' : s;
};

export default function LogViewer() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [detail, setDetail] = useState(null); // 자세히 보기 대상 로그

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await authFetch(`${API_BASE}/logs`);
      if (!res.ok) throw new Error(`로그 조회 실패 (${res.status})`);
      setLogs(await res.json());
    } catch (e) {
      setError(`${e.message} — 백엔드(8080)가 실행 중인지 확인하세요.`);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="logv">
      <div className="logv-head">
        <div>
          <h1 className="logv-title">활동 로그</h1>
          <p className="logv-sub">관리자 로그인 및 계정 작업 내역 (최근 200건)</p>
        </div>
        <button type="button" className="logv-refresh" onClick={load}>새로고침</button>
      </div>

      {error && <div className="logv-error">{error}</div>}

      <div className="logv-card">
        <table className="logv-table">
          <thead>
            <tr>
              <th style={{ width: 170 }}>시각</th>
              <th style={{ width: 210 }}>행위자</th>
              <th style={{ width: 110 }}>동작</th>
              <th>내용</th>
              <th style={{ width: 150 }}>IP</th>
              <th style={{ width: 90 }}>상세</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="logv-empty">불러오는 중…</td></tr>
            ) : logs.length === 0 ? (
              <tr><td colSpan={6} className="logv-empty">기록된 로그가 없습니다.</td></tr>
            ) : (
              logs.map((l) => (
                <tr key={l.intNum}>
                  <td className="logv-date">{l.dateReg}</td>
                  <td>{l.strActor}</td>
                  <td><span className={`logv-badge ${actionClass(l.strAction)}`}>{actionLabel(l.strAction)}</span></td>
                  <td className="logv-detail">{preview(l.textDetail)}</td>
                  <td className="logv-ip">{l.strIP}</td>
                  <td>
                    <button type="button" className="logv-more" onClick={() => setDetail(l)}>자세히</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {detail && (
        <div className="logv-modal-overlay" onMouseDown={() => setDetail(null)}>
          <div className="logv-modal" onMouseDown={(e) => e.stopPropagation()}>
            <h2 className="logv-modal-title">로그 상세</h2>
            <dl className="logv-meta">
              <div><dt>시각</dt><dd>{detail.dateReg}</dd></div>
              <div><dt>행위자</dt><dd>{detail.strActor}</dd></div>
              <div><dt>동작</dt><dd><span className={`logv-badge ${actionClass(detail.strAction)}`}>{actionLabel(detail.strAction)}</span></dd></div>
              <div><dt>IP</dt><dd>{detail.strIP}</dd></div>
            </dl>
            <div className="logv-detail-label">내용</div>
            <div className="logv-detail-full">{detail.textDetail || '(내용 없음)'}</div>
            <div className="logv-modal-actions">
              <button type="button" className="logv-modal-close" onClick={() => setDetail(null)}>닫기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
